import { ScrollAnimationType } from '../../../enums/scroll-animation-type.enum';

import { socialMediaItems } from '../../../constants/social-media-items.constants';

import ScrollInAnimationItem from '../../../components/scrollInAnimationItem/ScrollInAnimationItem';

import Arrow from '../../../assets/about/about-arrow.svg';

import styles from './AboutSocialMediaSection.module.scss';

const AboutSocialMediaSection = () => {
  return (
    <div className={styles['section']}>
      <div className={styles['content']}>
        <ScrollInAnimationItem animationType={ScrollAnimationType.slideInTop} delay="0.1s" threshold={0.3}>
          <h2>Social media</h2>
        </ScrollInAnimationItem>
        <ScrollInAnimationItem
          className={styles['arrow']}
          delay="0.2s"
          threshold={0.3}
          animationType={ScrollAnimationType.slideInLeft}
        >
          <img alt="" src={Arrow} />
        </ScrollInAnimationItem>
        <div className={styles['social-media-wrapper']}>
          {socialMediaItems.map(({ link, alternativeText, ImageComponent }) => (
            <ScrollInAnimationItem
              key={alternativeText}
              className={styles['social-media-animation-container']}
              delay="0.3s"
              threshold={0.3}
            >
              <a
                aria-label={alternativeText}
                className={styles['social-media-item']}
                href={link}
                rel="noreferrer"
                target="_blank"
              >
                <ImageComponent />
              </a>
            </ScrollInAnimationItem>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutSocialMediaSection;
